import { Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core'
import { Subject } from 'rxjs'
import { debounceTime, switchMap } from 'rxjs/operators'
import { QuickNote } from '../../../models/quicknote'
import { QuickNoteService } from '../../../services/quick-note.service'

@Component({
  selector: 'jml-lib-entity-quick-notes',
  templateUrl: './entity-quick-notes.component.html',
  styleUrls: ['./entity-quick-notes.component.scss']
})
export class EntityQuickNotesComponent implements OnChanges {
  @Input() ownerType: string
  @Input() ownerId: number

  @ViewChild('editor') editor: ElementRef

  note = new QuickNote()
  textChangeObserver: Subject<void> = new Subject()
  dirty = false

  quillModules = {
    clipboard: {
      matchVisual: false
    }
  }

  constructor(private quickNoteService: QuickNoteService) {}

  init() {
    this.quickNoteService.get(this.ownerType, this.ownerId).subscribe((quickNote) => (this.note = quickNote))

    this.textChangeObserver
      .asObservable()
      .pipe(
        debounceTime(1000),
        switchMap(() => {
          return this.quickNoteService.update(this.note)
        })
      )
      .subscribe(() => (this.dirty = false))
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.note = new QuickNote()
    this.init()
  }

  textChanged() {
    this.dirty = true
    this.textChangeObserver.next()
  }
}
